import { apiFetch, withAuth } from "../common/api";

const HOST = import.meta.env.VITE_API_HOST;

/**
 * @param {object} accessToken
 * @param {number} [customerId]
 * @returns {Promise<ForCustomerPackagesResponse>}
 */
export async function fetchForCustomer(accessToken, customerId) {
  let url = `${HOST}/api/v1/packages/for-customer`;
  if (customerId != null) {
    url += `?customer_id=${customerId}`;
  }

  const resp = await apiFetch(url, withAuth(accessToken));

  const data = await resp.json();
  console.debug("Fetched packages:", JSON.stringify(data));

  return data;
}

/**
 * @param {object} accessToken
 * @param {CalculateOrderRequest} req
 * @returns {Promise<CalculateOrderResponse>}
 */
export async function calculateOrder(accessToken, req) {
  const resp = await apiFetch(
    `${HOST}/api/v1/packages/calculate-order`,
    withAuth(accessToken, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    }),
  );
  if (resp.status !== 200) {
    throw await resp.json();
  }
  return await resp.json();
}

/**
 * @param {object} accessToken
 * @param {PresentMinutesRequest} req
 */
export async function presentMinutes(accessToken, req) {
  await apiFetch(
    `${HOST}/api/v1/customer/present-minutes`,
    withAuth(accessToken, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    }),
  );
}

/**
 * @param {object} accessToken
 * @returns {Promise<MinutesPackage[]>}
 */
export async function fetchAll(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/packages`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  const data = await resp.json();
  console.debug("Fetched packages:", JSON.stringify(data));
  return data;
}

/**
 * @param {object} accessToken
 * @param {SaveOrUpdateMinutesPackageRequest} req
 */
export async function saveOrUpdate(accessToken, req) {
  req.possibleDiscount = parseInt(req.possibleDiscount.replace("%", "")) / 100;
  const opts = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  const resp = await apiFetch(
    `${HOST}/api/v1/packages`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
}

/**
 * @param {object} accessToken
 * @param {number} packageId
 */
export async function archive(accessToken, packageId) {
  const opts = { method: "DELETE" };
  const resp = await apiFetch(
    `${HOST}/api/v1/packages/${packageId}`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status !== 200) {
    throw await resp.text();
  }
}
